import { omit, noop } from 'lodash/fp';
import { createMiddleware } from 'redux-beacon';
import { GoogleTagManager } from 'redux-beacon/targets/google-tag-manager';
import { logger } from 'redux-beacon/extensions/logger';

const createTrackingTargeting = (dataLayer) => {
  if (__DEVELOPMENT__) {
    return noop;
  }

  if (__SERVER__) {
    return (events) => {
      events.forEach((event) => {
        if (event.event || !event.hitType) {
          return;
        }

        dataLayer.push({
          ...event,
          event: event.hitType,
        });
      });
    };
  }

  return GoogleTagManager();
};

export const trackingMiddleware = (dataLayer) =>
  createMiddleware(
    {
      GTM_TRACK: omit(['type']),
    },
    createTrackingTargeting(dataLayer),
    {
      logger: __DEVELOPMENT__ ? logger : undefined,
    },
  );

export { track } from './actions';
export { default as hitTypes } from './hitTypes';
export { default as trackingCategory } from './trackingCategory';
export { default as withTracker } from './withTracker';
